module.exports = __webpack_public_path__ + "img/shipping-label.c48b6d22.png";